//js


function animateLogoClose() {
  $(".logo--close").css("visibility", "visible").animate(
    { opacity: 1 }, 
    100, // 0.2 seconds
    "swing", // jQuery easing option (can also use "linear")
    function() {
      // After fade in, delay and then fade out
      setTimeout(function() {
        $(".logo--close").animate(
          { opacity: 0 }, 
          100, 
          "swing", 
          function() {
            $(".logo--close").css("visibility", "hidden");
          }
        );
      }, 100); // 5 second delay
    }
  );
}

// Call the function in a loop
setInterval(animateLogoClose, 5000); // 5 seconds delay + 0.4 seconds for the fade in and out


$(document).ready(function(){
  $('.product_accordion_main summary').on('click', function() {    
    $(this).next('.accordion__content').slideToggle(300);
    $(this).toggleClass("open");
  });
});




